import { render, staticRenderFns } from "./BookingFormModal.vue?vue&type=template&id=2574dee9&scoped=true&"
import script from "./BookingFormModal.vue?vue&type=script&lang=js&"
export * from "./BookingFormModal.vue?vue&type=script&lang=js&"
import style0 from "./BookingFormModal.vue?vue&type=style&index=0&id=2574dee9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574dee9",
  null
  
)

export default component.exports